import React from 'react'

import Card from '../../../UI/Card/Card'
import EmpDetailHeader from './EmpDetailHeader/EmpDetailHeader'
import EmpDetailBody from './EmpDetailBody/EmpDetailBody'
import EmpDetailFooter from './EmpDetailFooter/EmpDetailFooter'

import Spinner from '../../../UI/Spinner/Spinner'
import { withTranslate } from 'react-redux-multilingual'

const empDetailContent = ({
  action,
  formControls,
  positionDetails,
  inputChanged,
  saved,
  cancelled,
  addRowClicked,
  deleteRowClicked,
  actionToClicked,
  delegateClicked,
  positionInputChanged,
  loading,
  imageSrc,
  dropdownOptions,
  primaryRowIndex,
  formIsValid,
  edit,
  validate,
  translate
}) => {
  let display = <Spinner />
  let data = (
    <Card>
      <EmpDetailHeader pageAction={translate(action)} />
      <EmpDetailBody
        forms={formControls}
        empPositions={positionDetails}
        inputChanged={inputChanged}
        addRowClicked={addRowClicked}
        deleteRowClicked={deleteRowClicked}
        actionToClicked={actionToClicked}
        delegateClicked={delegateClicked}
        positionInputChanged={positionInputChanged}
        imageSrc={imageSrc}
        dropdownOptions={dropdownOptions}
        primaryRowIndex={primaryRowIndex}
        edit={edit}
      />
      <EmpDetailFooter
        empPositions={positionDetails}
        dropdownOptions={dropdownOptions}
        formIsValid={!formIsValid}
        saveButtonClicked={saved}
        cancelButtonClicked={cancelled}
        validate={validate}
      />
    </Card>
  )

  if (!loading) {
    display = data
  }
  return display
}

export default withTranslate(empDetailContent)
